export default {
  user: {},
  token: ''
}
